import type { U2104Affiliation } from "../../../U2104Service";

// Paramètres pour les handlers des actions d'importation d'un usager
export interface U2104UseImportAffiliationHandlersParams<T = any> {
  doImportFn: (orgId: string, affiliation: U2104Affiliation) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Type de retour pour les handlers des actions d'importation d'un usager
export interface U2104UseImportAffiliationHandlersReturn {
  importUser: (orgId: string, affiliation: U2104Affiliation) => void;
}

// Handlers pour les actions d'importation d'un usager
export function useU2104UseImportAffiliaitonHandlers<T extends { id: string } = any>({
  doImportFn,
  onSuccess,
  onError,
}: U2104UseImportAffiliationHandlersParams<T>): U2104UseImportAffiliationHandlersReturn {
  const importUser = async (orgId: string, affiliation: U2104Affiliation) => {
    try {
      const response = await doImportFn(orgId, affiliation);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { importUser };
}
